import {
    Box,
    Button,
    CircularProgress,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    Typography,
} from '@mui/material';
import axios from 'axios';
import { Plus } from 'lucide-react';
import EditIcon from '@mui/icons-material/Edit';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apiUrl from '../../Config';

const DisplayTermsAndPrivacy = () => {
    const [title, setTitle] = useState('termsandconditions');
    const [userType, setUserType] = useState('user');
    const [loading, setLoading] = useState(false);
    const [termsprivacy, setTermsPrivacy] = useState(null);
    const [errors, setErrors] = useState('');
    const navigate = useNavigate();

    const titles = [
        { name: 'Terms and Conditions', value: 'termsandconditions' },
        { name: 'Privacy Policy', value: 'privacypolicy' },
    ];

    const userTypes = [
        { name: 'User', value: 'user' },
        { name: 'Technician', value: 'technician' },
        { name: 'Showroom', value: 'showroom' },
    ];

    const handleTitleChange = (event) => setTitle(event.target.value);
    const handleUserTypeChange = (event) => setUserType(event.target.value);
    const handleAddClick = () => navigate('/create-edit-terms-privacies');

    const getTermsAndPrivacy = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${apiUrl}/termsprivacy/gettermsprivacy?title=${title}&type=${userType}`
            );
            if (response.data.status === true) {
                setTermsPrivacy(response.data.data);
                setErrors('');
            }
        } catch (error) {
            setErrors(error?.response?.data?.message || 'Error fetching content');
        } finally {
            setLoading(false);
        }
    };
    const handleEdit = (faq) => {
        navigate('/create-edit-terms-privacies', { state: { termsprivacy } });
    };

    useEffect(() => {
        getTermsAndPrivacy();
    }, [userType, title]);

    return (
        <Box mt={1} sx={{ padding: { xs: 2, sm: 2, md: 4, lg: 4 } }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', mb: 3 }}>
                <Typography variant="h4">
                    Terms and Conditions, Privacy Policies
                </Typography>
                <Box sx={{ textAlign: { xs: 'left', md: 'right' } }}>
                    <Button
                        variant="contained"
                        onClick={handleAddClick}
                        sx={{ borderRadius: '5px', gap: 1 }}
                    >
                        <Plus size={23} />
                        <Typography>Add New</Typography>
                    </Button>
                </Box>
            </Box>

            {/* Filters and Add Button */}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    gap: 3,
                    flexWrap: 'wrap',
                }}
            >
                <FormControl
                    size="small"
                    sx={{ width: { xs: '100%', sm: '100%', md: '200px', lg: '200px' } }}
                >
                    <InputLabel id="title-label">Select Title</InputLabel>
                    <Select
                        labelId="title-label"
                        value={title}
                        label="Select Title"
                        onChange={handleTitleChange}
                    >
                        {titles.map((item) => (
                            <MenuItem key={item.value} value={item.value}>
                                {item.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl
                    size="small"
                    sx={{ width: { xs: '100%', sm: '100%', md: '200px', lg: '200px' } }}
                >
                    <InputLabel id="user-type-label">Select User Type</InputLabel>
                    <Select
                        labelId="user-type-label"
                        value={userType}
                        label="Select User Type"
                        onChange={handleUserTypeChange}
                    >
                        {userTypes.map((item) => (
                            <MenuItem key={item.value} value={item.value}>
                                {item.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>


            {/* Content Display */}
            <Box mt={4}>
                {loading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" height={200}>
                        <CircularProgress />
                    </Box>
                ) : errors ? (
                    <Typography color="error" mt={2} textAlign="center">
                        {errors}
                    </Typography>
                ) : termsprivacy ? (
                    <Box
                        sx={{
                            p: 3,
                            mt: 2,
                            border: '1px solid #ccc',
                            borderRadius: 2,
                            backgroundColor: '#f9f9f9',
                        }}
                    >
                        <Grid container justifyContent="space-between" alignItems="center">
                            <Grid item>
                                <Typography variant="subtitle1">
                                    {termsprivacy?.title === "termsandconditions" ? "Terms and Conditions" : "Privacy Policy"}
                                </Typography>

                            </Grid>
                            <Grid item> <IconButton size="small" onClick={(e) => { handleEdit(termsprivacy); }}>
                                <EditIcon fontSize="small" />
                            </IconButton></Grid>
                        </Grid>

                        <Box mt={2}>
                            <Typography
                                component="div"
                                dangerouslySetInnerHTML={{ __html: termsprivacy?.content }}
                            />
                        </Box>
                    </Box>
                ) : (
                    <Typography>No content found for this type.</Typography>
                )}
            </Box>
        </Box>
    );
};

export default DisplayTermsAndPrivacy;
